import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { useCurrentUserModule } from '@/store/global/currentUser';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class UpdateOnlineUsersForStoryMap extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'UpdateOnlineUsersForStoryMap';

    public constructor(public onlineUsers: string[], public storymapId: string) {
        super(UpdateOnlineUsersForStoryMap.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: UpdateOnlineUsersForStoryMap): void => {
    const currentUserStore = useCurrentUserModule();
    const currentUserName = currentUserStore.state.fullName;

    state.onlineUsers.splice(0, state.onlineUsers.length);
    state.onlineUsers.push(...action.onlineUsers.filter((user) => user !== currentUserName));
    //state.onlineUsers.push('Neo', 'Trinity', 'Morpheus', 'Agent Smith', 'Oracle');

    //check if state.navigationState.activeCardsByOtherUsers contains users that are not in state.onlineUsers anymore
    // and remove them from activeCardsByOtherUsers and card.activeUsers
    for (const user in state.navigationState.activeCardsByOtherUsers) {
        if (!state.onlineUsers.includes(user)) {
            const card = state.navigationState.activeCardsByOtherUsers[user];
            const index = card?.activeUsers?.indexOf(user);
            if (card && index !== null && index !== -1) {
                card.activeUsers.splice(index, 1);
            }
            delete state.navigationState.activeCardsByOtherUsers[user];
        }
    }
};

//@ts-ignore
registerReducer(UpdateOnlineUsersForStoryMap.ACTION_TYPE, reducer);
